import * as Yup from 'yup'

export const PasswordSchema = Yup.string()
  .min(12, 'Password must be at least 12 characters long')
  .matches(
    /[!@#$%^&*(),.?":{}|<>]/g,
    'Password must contain at least 1 special character'
  )
  .matches(/[A-Z]+/g, 'Password must contain at least 1 uppercase letter')
  .matches(/[a-z]+/g, 'Password must contain at least 1 lowercase letter')
  .matches(/\d+/g, 'Password must contain at least 1 number')
  .required('Password must be at least 12 characters long')

export const PasswordConfirmationSchema = (ref: any) =>
  Yup.string()
    .typeError('Password confirmation is required')
    .oneOf([Yup.ref(ref), undefined], 'Passwords must match')
    .required('Password confirmation is required')

export const SignupSchema = Yup.object().shape({
  password: PasswordSchema,
  password_confirmation: PasswordConfirmationSchema('password'),
  role: Yup.string()
    .notOneOf(['placeholder'], 'Please select a role')
    .required('Please select a role'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email address is required'),
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Last name is required'),
  legal_agree: Yup.boolean()
    .default(false)
    .oneOf(
      [true],
      'You must agree to our terms and conditions and our privacy policy to continue'
    )
    .required(
      'You must agree to our terms and conditions and our privacy policy  to continue'
    ),
})
